import dayjs from 'dayjs'
import React from 'react'

import { Tag } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import type { Post } from '../../../../types'
import { LiveStreamScheduleTag } from '../../components/LiveStreamScheduleTag'
import { ScheduleTag } from '../../components/ScheduleTag'
import type { FormValues } from '../../types'

type Props = {
  post: Post
  liveStreamStartDate?: string
  updatePost: (values: FormValues) => void
}

export const PostTag = ({ post, liveStreamStartDate, updatePost }: Props) => {
  const { values } = useFormikContext<FormValues>()

  const updatePostData = (liveAt: FormValues['liveAt']) => {
    updatePost({ ...values, liveAt })
  }

  const updateLiveStreamStartDate = (liveStreamStartDate: Date) => {
    updatePost({ ...values, liveStreamStartDate: liveStreamStartDate.toISOString() })
  }

  if (post.statuses.schedule === 'Future') {
    return <ScheduleTag currentDate={new Date(post.liveAt)} onDateUpdate={updatePostData} />
  }

  if (liveStreamStartDate && dayjs(liveStreamStartDate).isAfter(dayjs())) {
    return <LiveStreamScheduleTag onDateUpdate={updateLiveStreamStartDate} />
  }

  return <Tag label="Published" appearance="success" size="large" />
}
